export default __webpack_public_path__ + "static/media/mad-future-01.9f1f76b0.jpg";